import ManageProductTable from "../ManageProductTable/ManageProductTable";




const ManageAllProducts = () => {
   
    
    return (
        <div className="text-center container ">

        
        <div className="">
            <h3>Manage Product Table</h3>
            <ManageProductTable></ManageProductTable>
            
        </div>
        </div>
    );
};

export default ManageAllProducts;